<template lang="pug">
  div()
    section.grey.lighten-3()
      v-tabs(fixed-tabs dark background-color='primary', slider-color='white' color='white')
        v-tab
          .white--text.font-weight-bold() Vehicles
        v-tab-item
        
          vehicle-auto-complete.grey.lighten-3.px-4(v-model='vehicleID' :key="vehicleKey" label="Select Vehicle*" placeholder="Vehicle to View" :items="this.items")
      
          .dateButtonContainer.grey.lighten-3()
            button.dateButton2.primary.subtitle-2.white--text(type="input" v-html="getDateRange" @click="onOpenDialog") 
          
              
            

          .SideBarFilter.grey.lighten-3.pa-4
            .d-flex()
              v-btn(outlined small color="primary"  @click="openTimelineReport")
                | Download
                v-icon.ml-2(:size="18") print
              v-btn.mx-3(outlined small color="primary"  @click="openAllTimelineReport")
                | All
                v-icon.ml-2(:size="18") mail
            //-- v-menu(bottom left)
                template(#activator="{ on }")
                  v-btn(outlined small v-on="on", color='primary')
                    span {{ sortBy }}
                    v-icon.timelineFilter(large) arrow_drop_down

            v-icon filter_list

          //-  Moving Vehicles
          .scrollSideBar(:style="{'height':`${height-15}px`}")
            .grey.lighten-3(v-if="$store.state.timeline.timeline_bucket_data.length > 0" v-for="(item,index) in $store.state.timeline.timeline_bucket_data" :key="item.bucket" )
              .timelineItem(@click="onSelect(index)")
                .timelineBar(v-if="item.distance > 0" :style="{width:`${(item.distance/$store.state.timeline.timeline_max_distance)*100}%`}")
                .timelineContent.d-flex(:class="$store.state.timeline.currentIndex == index?'font-weight-bold primary--text':'grey--text text--darken-2'")
                  .d-flex.flex-column()
                    .caption() {{getFriendlyTime(item.min_time)  }} - {{getFriendlyTime(item.max_time)}}
                    .caption() {{getFriendlyDate(item.max_time)  }}
                  .d-flex.flex-column.align-end
                    .font-weight-bold() {{item.distance/1000}} Km
                    .d-flex()
                      .caption.grey--text() {{getDuration(item)}}
                      // --.caption.d-flex.font-weight-regular(v-if="item.efficiency")
                            .span() &nbsp; | &nbsp;
                            v-icon(color="grey" :size="18" ) local_gas_station
                            .span() &nbsp;{{item.efficiency.toFixed(2)}} Km/L

          
        v-tab
          .white--text.font-weight-bold() Drivers
        v-tab-item
        
          v-text-field.grey.lighten-3.pa-4(append-icon='search', hide-details label='Search Driver', text)
          .SideBarFilter.grey.lighten-3.pa-4
            v-menu(bottom left)
              template(#activator="{ on }")
                v-btn(outlined small v-on="on", color='primary')
                  span {{ sortBy }}
                  v-icon.tripFilter(large) arrow_drop_down
          
            v-icon filter_list




    v-dialog(v-model="showDialog" width="500" height="500" persistent )
      v-card()
     
        .d-flex.justify-space-between.primary.pa-2()
          .d-flex.flex-column.white--text
            .caption() Hello World
            .title(v-html="getDateRangeLong")
  

        v-divider()
        vue-ctk-date-time-picker(
          v-model="thedate" 
          inline 
          :no-header="true"
          :right="false" 
          :range="true" 
          :button-color="$vuetify.theme.themes.light.primary" 
          :color="$vuetify.theme.themes.light.primary"
          :custom-shortcuts="shortcuts"
          )
        v-divider()
          
        v-layout(justify-end )
          v-btn.mx-2.my-4.grey--text(@click="onCancelDialog"  outlined small) Cancel
          v-btn.mx-2.my-4(@click="onUpdateDate" color="primary" small) Update
          



  </template>

<script>
import TripSidebarDivider from "@/modules/maps/components/ui/SideBar/TripSidebarDivider";
import TripMovementContainer from "@/modules/maps/components/ui/SideBar/TripMovementContainer";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import VehicleAutoComplete from "@/modules/global/components/forms/VehicleAutoComplete";
import moment from "moment";


export default {
  props:["vehicle_id","items","height"],
  components: {
    TripSidebarDivider,
    TripMovementContainer,
    VueCtkDateTimePicker,
    VehicleAutoComplete
  },

  data: () => ({
    vehicleKey: 1,
    sortBy: "",
    thedate: { start: "2020-01-23 12:00 am", end: "2020-01-27" },

    shortcuts: [
      { key: "today", label: "Today", value: 0 },
      { key: "yesterday", label: "Yesterday", value: "-day" },
      { key: "last7Days", label: "Last 7 days", value: 7 },
      { key: "last14Days", label: "Last 14 days", value: 14 },
      { key: "last30Days", label: "Last 30 days", value: 30 }
    ],
    showDialog: false,
    initializedDate: false,
  }),



  mounted() {
    this.vehicleID = this.vehicle_id;
  },

  computed: {
    getReportURL: function(){
      return this.reportURL("renderTripTimeline")
    },

    getAllReportURL: function(){
      return this.reportURL("renderTripAllTimeline")
    },

    originalDate: {
      get: function() {
        return this.$store.getters["timeline/getDateTimelineRange"];
      },
      set: function(value) {
        this.$store.commit("timeline/setDateTimelineRange", value);
        this.$store.commit("trips/setDateRange", value);
      }
    },

    vehicleID: {
      get: function() {
        return this.$store.state.timeline.currentVehicleID;
      },
      set: function(value) {
        if(value != null){
          this.$store.commit("timeline/setCurrentVehicleID",value)
          this.$store.commit("trips/setCurrentVehicleID",value)
          this.$store.commit("vehicles/devices/setCurrentIndexByVehicleID",value)
          localStorage.setItem("mapSelectedVehicleId", value);
        }
        if(this.initializedDate === false){
          this.resetDateRangeToVehicle()
        }

        this.onRefreshServer();
      }
    },
    getDateRange: function() {

      let startDate = moment(
        this.originalDate.start,
        "YYYY-MM-DD h:mm a"
      ).format("ddd, Do MMM YY");

      // check if start and end date are the same
      let endDate = null;

      if (this.originalDate.end != null) {
        endDate = moment(this.originalDate.end, "YYYY-MM-DD h:mm a").format(
          "ddd, Do MMM YY"
        );
      }
      if (endDate == null) {
        return startDate;
      }

      if (startDate.toString() == endDate.toString()) {
        return startDate;
      } else {
        return startDate + "&nbsp;&nbsp; &mdash; &nbsp;&nbsp;" + endDate;
      }
    },

    getDateRangeLong: function() {
      // console.log(this.thedate.start);
      // console.log(this.thedate.end);
      let startDate = moment(this.thedate.start, "YYYY-MM-DD h:mm a").format(
        "DD MMMM YYYY"
      );

      // check if start and end date are the same
      let endDate = null;

      if (this.thedate.end != null) {
        endDate = moment(this.thedate.end, "YYYY-MM-DD h:mm a").format(
          "DD MMMM YYYY"
        );
      }

      if (endDate == null) {
        return startDate + " &ndash; click end date";
      }

      if (startDate.toString() == endDate.toString()) {
        return startDate;
      } else {
        return startDate + " &ndash; " + endDate;
      }
    }
  },

  methods: {

    reportURL: function(type) {
      let endDate = null;
      if (this.thedate.end == null) {
        endDate = moment(this.thedate.start, "YYYY-MM-DD h:mm a").endOf("day").toISOString();
      }else{
        endDate = moment(this.thedate.end, "YYYY-MM-DD h:mm a").toISOString()
      }
      const params = new URLSearchParams({
        type: type,
        account_id: this.$store.state.profile.userInfo.account_id,
        vehicle_id: this.vehicleID,
        from: moment(this.thedate.start, "YYYY-MM-DD h:mm a").toISOString(),
        to: endDate,
      })
      return `/api/renderhtml?${params}`
    },

    openTimelineReport: function() {
      window.open(
          this.getReportURL,
          '_blank',

      )
    },

    openAllTimelineReport: function() {
      window.open(
          this.getAllReportURL,
          '_blank',
      )
    },

    resetDateRangeToVehicle:function() {
      if (this.vehicleID == null) {
        return;
      }

      let mapDateString = localStorage.getItem("mapsDateRange")
      let dateRangeObject = {};
      if (mapDateString != null && mapDateString.length > 0) {

        let obj = JSON.parse(mapDateString);
        dateRangeObject.start = moment(obj.startISODate).format("YYYY-MM-DD h:mm a");
        if (obj.endISODate == null) {
          dateRangeObject.end = null
        } else {
          dateRangeObject.end = moment(obj.endISODate).format("YYYY-MM-DD h:mm a");
        }


      } else {


        dateRangeObject.start = moment(this.$store.getters["vehicles/devices/getActiveTrackerEnabledDevices"].last_online_date).subtract(1, "day").startOf("day").format("YYYY-MM-DD h:mm a");

        dateRangeObject.end = moment(this.$store.getters["vehicles/devices/getActiveTrackerEnabledDevices"].last_online_date).subtract(1, "day").endOf("day")
            .format("YYYY-MM-DD h:mm a");
        // set the date and time for the timeline object;
      }
      this.$store.commit("timeline/setDateTimelineRange", dateRangeObject);
      this.$store.commit("trips/setDateRange", dateRangeObject);
      this.thedate = dateRangeObject;
      this.initializedDate = true;

    },

    onUpdateDate: function() {

      this.showDialog = false;

      this.onRefreshServer();
    },

    onRefreshServer: function() {

      if (this.$store.state.timeline.currentVehicleID == null) {
        return;
      }

      this.$store.commit("timeline/setDateTimelineRange",{start:this.thedate.start!=null?this.thedate.start.toString():null,end:this.thedate.end != null?this.thedate.end.toString():null})
      this.$store.commit("trips/setDateRange",{start:this.thedate.start!=null?this.thedate.start.toString():null,end:this.thedate.end != null?this.thedate.end.toString():null})

      this.$store.dispatch("timeline/loadTimelineBuckets").then(() => {
        // // update the time
        this.originalDate = JSON.parse(JSON.stringify(this.thedate));
        this.$store.commit("timeline/setCurrentIndex",-1)
      });


      this.$store.dispatch("timeline/loadTimelineAvl")
    },

    onOpenDialog: function() {
      this.thedate = JSON.parse(JSON.stringify(this.originalDate));
      this.showDialog = true;
    },

    onCancelDialog: function() {
      this.showDialog = false;

      console.log(this.originalDate);
      console.log(this.thedate);
      this.thedate = JSON.parse(JSON.stringify(this.originalDate));
    },

    onSortBy: function(label) {
      switch (label) {
        case "NAME":
          // todo: call the sortByName getter function
          break;
        case "DISTANCE":
          // todo: call the sortByDistance getter function
          break;

        default:
          // todo: call the sortByName getter function
          break;
      }
      this.sortBy = label;
    },
     onPrint: function(){
        console.log(`Print the Dodcument ${this.vehicleID} ${moment(this.thedate.start, "YYYY-MM-DD h:mm a").toISOString()} - ${moment(this.thedate.end, "YYYY-MM-DD h:mm a").toISOString()}`)
      
      },

    getFriendlyTime(theTime){
      if (theTime == null){
        return null;
      }
      return moment(theTime).format("h:mm a")
    },

    getFriendlyDate(theTime){
      if (theTime == null){
        return null;
      }
      return moment(theTime).format("ddd, Do MMMM YYYY")
    },

    onSelect(index){
      console.log("Loading Timeline Data")
      this.$store.commit("timeline/setCurrentIndex",index)
      this.$store.dispatch("timeline/loadSectionTimelineAvl")
    },

    getDuration(item){
      if (item.max_time == null)
        return null

      let minTime = moment(item.min_time)
      let theDuration = moment.duration(moment(item.max_time).diff(minTime))
      if (theDuration.hours() > 0) {
        return theDuration.hours()+"h "+theDuration.minutes()+"m "+theDuration.seconds()+"s"
      }else if (theDuration.minutes() > 0){
        return theDuration.minutes()+"m "+theDuration.seconds()+"s"
      }else{
        return theDuration.seconds()+"s"
      }

    }
  },

 

};
</script>

<style scoped>
.SideBarFilter {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  padding: 0px 17px 0px 8px;
}

.tripFilter {
  margin-left: 0px;
  margin-right: -15px;
}

.tripBold {
  font-weight: bolder;
}

.dateTimeHeader {
}

.dateButton2 {
  width: 90%;
  border-radius: 15px;
  padding: 5px 5px;
  max-width: 400px;
}

.dateButtonContainer {
  display: flex;
  justify-content: center;
}

.vehicleSearch {
  width: 90%;
  max-width: 400px;
  padding: 5px 5px;
}

.timelineItem{
  width: 100%;
  height: 50px;
  border-bottom: 1px solid #CCCCCC;
  position: relative;
  cursor: pointer;
}

.timelineItem:hover{
  background-color: #ffffff;
}

.timelineBar{

  height: 50px;
  background-color: #B8B8B8;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  opacity: 0.3;
}

.timelineContent{
  position: absolute;
  top: 0px;
  left: 0px;
  height: 100%;
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 10px 10px;
  font-size: 14px;
}
.scrollSideBar{
  overflow-y: scroll;
}
</style>
